<template>
    <div :class="{'uk-editable': editable&&!empty}" class="lam-attachment">
        <div class="uk-text-center">
            <open-icon glyph="paperclip" />
        </div>
        <div class="lam-dropzone">
            <file-upload-form
                :value="!!attachment_record ? attachment_record.shareable_url : ''"
                :accepts="upload_accepts(name)"
                :size="size"
                :show-upload-icon="showUploadIcon"
                :uploading="!!uploading[name]"
                :uploaded="uploaded[name]||0"
                :editable="editable"
                :copy-pastable="copyPastable"
                @upload="upload_file_list(name, $event)"
            >
                <template v-slot:read_only>
                    <div class="uk-text-center">
                        <a
                            :href="attachment_record.shareable_url"
                            title="View"
                            target="_blank"
                        >
                            {{ attachment_record.name }}
                        </a>
                    </div>
                </template>
                <small slot="message-drag-or-click">
                    <span v-if="!empty">
                        {{ attachment_record.name }}
                    </span>
                    <span v-else>Drop a file or click to upload</span>
                </small>
            </file-upload-form>
        </div>
        <div v-if="editable&&!empty" class="uk-text-center">
            <a href class="uk-icon-button uk-icon-close" title="Delete" @click.prevent="confirm_clear_file(name)"></a>
            <a :href="attachment_record.shareable_url" class="uk-icon-button uk-icon-external-link" title="View" target="_blank"></a>
        </div>
    </div>
</template>

<script type="text/javascript">
import handles_uploads from "../mixins/HandlesUploads"

import FileUploadForm from "./FileUploadForm"
import OpenIcon from "../ui/OpenIcon"

export default {
    components: {
        FileUploadForm,
        OpenIcon
    },
    mixins: [handles_uploads],
    methods: {
        upload_accepts (name, filename = null) {
            if(filename) return !this.acceptsExtensions || !!filename.match(this.acceptsExtensions)
            return this.accepts
        },
        upload_data (name) {
            const data = { entity: this.entity, id: this.ownerId }
            if(this.recordId !== null) data.data = { attachment_id: this.recordId }
            return data
        },
        upload_attach_error (name, error) {
            this.$error(error.message)
        },
        upload_attached (name, response) {
            if(!!response && !!response.data && !!response.data.success) this.$success(response.data.success)
            this.$emit("attached", response)
        },
        upload_detached () {
            const attachment = this.attachment_record
            if(attachment) {
                this.$emit("detached", attachment)
                this.$store.dispatch("DUSTING", { entity: "attachment", record_id: attachment.id })
            }
        }
    },
    computed: {
        attachment_record () {
            if(!this.ownerId) return null
            if(this.recordId !== null) return this.raw_attachment_records.find(attachment => attachment.id === this.recordId)
            return this.raw_attachment_records.find(attachment => (attachment.owner_type === this.ownerType) && (attachment.owner_id === this.ownerId))
        },
        empty () {
            return !this.attachment_record || !this.attachment_record.shareable_url
        }
    },
    props: {
        name: {
            type: String,
            default: "attachment"
        },
        entity: {
            type: String,
            required: true
        },
        ownerType: {
            type: String,
            required: true
        },
        ownerId: {
            type: Number,
            required: true
        },
        recordId: {
            validator: prop => (prop === null) || (typeof prop === "number"),
            default: null
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal)$/i),
            default: "normal"
        },
        showUploadIcon: {
            type: Boolean,
            default: true
        },
        accepts: {
            type: String,
            default: ""
        },
        acceptsExtensions: {
            type: Object,
            default: null
        },
        copyPastable: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: true
        }
    }
}
</script>
